/**
 * Shared copy for the plan-group chooser (ADR-0123). The chooser groups plans by
 * audience — an "individual" group and an "organisation" group — so a buyer picks
 * who a plan is for before which plan. Kept here (shared-string rule) so the
 * paywall link and the chooser never drift. Web-only: the chooser is opened from
 * the paywall's team link, which itself only renders on web with orgs enabled.
 */
export enum PlanChooserMessage {
  /** Modal heading. */
  Title = 'Choose your plan',
  /** Group segment — audience, not cadence. */
  GroupIndividual = 'For you',
  GroupOrganisation = 'For your team',
  /** Primary CTA. Individual → returns to the paywall with the plan selected;
   *  org → hands off to team signup (register-organization). */
  Continue = 'Continue',
  /** Paywall affordance that opens the chooser (web + orgs enabled only). Phrased
   *  as the hook, since individual plans are already visible on the paywall. */
  TeamLink = 'Buying for a team? See plans',
  /** Org tier card sub-labels. */
  SeatsSuffix = 'seats',
  PerSeatSuffix = '/seat',
  /** Empty state if no plans resolve for the active group. */
  NoPlans = 'No plans are available right now.',
}
